define([
	"dojo/_base/declare",
	"csi/form/Widget",
	"csi/reflection",
	"csi/xml"
], function(declare, Widget, reflection, xml) {

	return declare(Widget, {
		_getDependencyUrl: function(/*csi.def.Field*/fieldDep, /*csi.def.Field*/field, /*String*/urlRoot) {
			var value = this.inherited(arguments);

			if (field.m_dependency == "ClassName") {
				value = reflection.getClassUrl(value);
			}

			return value;
		},

		_resolveView: function() {
			// summary: make sure the name of ExportDefinition is 23 characters or less
			var ctx = this.getSourceContext();
			var nodeExportBatch = ctx.getNode();
			if (nodeExportBatch) {
				var nodeExportParams = ctx.cache.getNode(nodeExportBatch.ExternalExporterParameters);
				if (nodeExportParams?.DBType == "Oracle") {
					var field = this.defView.getField(xml.ATTR_NAME);
					field.widgetParams = field.widgetParams || {};
					field.widgetParams.maxlength = 23;
					field.widgetParams.promptMessage = "Export_OracleTableNameIsTooLong";
				}
			}

			this.inherited(arguments);
		}
	});
});